module.exports = __webpack_public_path__ + "img/P04-20180400-002_1.aa68da03.jpg";